import { Colors } from '../../consts/Colors';
export default class Card3 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;
        this.imgName = cardData.image
        this.zoneId = cardData.zoneId;
        this.zoneDropped = undefined
        this.isGood = false
        this.isCorrect = false
        this.isFirstDrop = true

        this.scaleOut = cardData.scale
    
        this.deck = deck

        this.cardImage = this.scene.add.image(0, 0, this.imgName).setOrigin(0.5);
        this.add(this.cardImage);

        this.badAnswerLogo = this.scene.add.image(this.cardImage.width/2 - 10, -this.cardImage.height/2+10, 'badAnswer3').setOrigin(0.5).setAlpha(0)
        this.add(this.badAnswerLogo)

        this.setSize(this.cardImage.width, this.cardImage.height);
        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this)

        this.setScale(this.scaleOut)
    }

    drop(pointer, gameObject, dropZone) {
        // On modifie la zone
        let currentDroppedCard = dropZone.onDrop(gameObject)
        if(currentDroppedCard !== undefined){
            currentDroppedCard.reset()
        }

        if(gameObject.zoneDropped != undefined){
            gameObject.zoneDropped.reset()
        }

        // On valide la carte
        gameObject.zoneDropped = dropZone
        gameObject.isDone = true
        gameObject.x = dropZone.x - gameObject.parentContainer.x
        gameObject.y = dropZone.y - gameObject.parentContainer.y
        gameObject.setScale(1)

        // On donne l'info au deck
        gameObject.deck.update()
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            if(gameObject.zoneDropped != undefined){
                gameObject.zoneDropped.reset()
            }
            gameObject.resetPosition(this.scaleOut)
        }
    }

    onDrag() {
        
    }

    setGood() {
        if (this.isGood === false) {
            this.isGood = true
            this.cardImage.setTexture(this.imgName + "True")
            this.zoneDropped.destroy()
        }
    }
    setBad() {
        this.badAnswerLogo.setAlpha(1)
        this.cardImage.setTexture(this.imgName + "False")
    }

    reset(){
        this.cardImage.setTexture(this.imgName)
        this.badAnswerLogo.setAlpha(0)
        this.zoneDropped = undefined
        this.isDone = false
        this.resetPosition(this.scaleOut)
    }

    resetPosition(scale = 1, duration = 300 ) {
        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: scale,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
}